// Ce module a pour but de simplifier le dialogue avec les LocalDate and LocalDateTime de java
// LocalDate et LocalDateTime sont utilises pour eviter les decalages entre le client et le serveur quand ils n'ont pas les memes reglage horaires
// Ils se traduisent tous deux comme des type number [] en JS

import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Modules material utilises
import { MatAutocompleteModule } from '@angular/material/autocomplete';

// Composants graphiques
import { SuggestableInputComponent } from './components/suggestable-input.component';
import { SuggestableInputJSComponent } from './components/suggestable-input-js.component';

// Services metier

// Pipes

// Bridges avec la partie anguler
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		
		MatAutocompleteModule,
	],
	providers: [
	],
	declarations: [
		SuggestableInputComponent,
		SuggestableInputJSComponent,
	],
	exports: [
		SuggestableInputComponent,
		SuggestableInputJSComponent,
	]
})
export class SuggestableInputModule {
	constructor() { }
}

// Initialisation des directives pour usage dans les templates angular-js
angular.module('auroraApp') //
	.directive('suggestableInputJs',
		downgradeComponent({ component: SuggestableInputJSComponent })
	) //
;